<template>

  <!--  <v-menu left open-delay="100ms">-->

  <!--    <template v-slot:activator="{ on, attrs }">-->

      <v-btn @click="wellClick($event)" style="padding: 0 0 0 0;"
             v-bind="attrs" v-on="on">
        <span>{{title}}</span>
      </v-btn>

<!--    </template>-->

<!--    <v-card>-->
<!--      <v-card-title>-->
<!--        Well Title-->
<!--      </v-card-title>-->
<!--      <v-card-text>-->
<!--        Описание-->
<!--      </v-card-text>-->
<!--    </v-card>-->

<!--  </v-menu>-->
</template>

<script>

	import {
		VContainer,
		VTooltip
	} from 'vuetify'

	export default {
		name: 'well-of-plate',
		components: {
			VContainer,
			VTooltip
		},

		data: function () {
			return {
				title: "W",
			}
		},

		props: {
			well: {
				type: Object,
				default: null
			}
		},

		methods: {
			well_click: function (event) {
				console.debug("WellOfPlateComponent.well_click() ")
			},

		},
	}
</script>

<style scoped>

</style>